import React from "react";

import { useCancelScheduledPropertyBilling } from "manager/hooks/api";
import { Property } from "manager/interfaces/api";
import { NOTIFICATIONS } from "shared/config/constants";
import useModal from "shared/hooks/useModal";
import { openNotification } from "shared/utils/ui";

import { expectedBillingSnapshot } from "./billingDisplay";
import CancelScheduledModal from "./CancelScheduledModal";

interface CancelScheduledModalContainerProps {
  property: Property;
  onSuccess?: () => void;
}

const CancelScheduledModalContainer = ({
  property,
  onSuccess,
}: CancelScheduledModalContainerProps) => {
  const { closeActiveModalDialog } = useModal();
  const { cancelScheduledPropertyBilling, isSaving } =
    useCancelScheduledPropertyBilling();

  const submit = async () => {
    await cancelScheduledPropertyBilling({
      propertyId: property.id,
      payload: expectedBillingSnapshot(property),
    });
    openNotification(
      `Cancelled the scheduled change for ${property.name}.`,
      NOTIFICATIONS.info
    );
    closeActiveModalDialog();
    onSuccess?.();
  };

  return (
    <CancelScheduledModal
      property={property}
      submit={submit}
      submitting={isSaving}
    />
  );
};

export default CancelScheduledModalContainer;
